<a *ngIf="showTranscript && transcriptUrl" [href]="transcriptUrl" target="_blank" class="transcript" matTooltip="{{'Common.Notifications.OpensInNewWindow' | translate}}">Transcript</a>
<video #media [src]="videoSrc" controls controlslist="nodownload" playsinline (play)="onPlay()">
	{{'Common.Notifications.VideoNotSupported' | translate}}
	<track *ngIf="captionSrc" [src]="captionSrc" srclang="{{translateService.currentLang.toLocaleUpperCase()}}" label="{{translateService.currentLang.toLocaleUpperCase()}}" kind="subtitles" [default]="captionsOn">
</video>
<div class="skip-controls">
	<button mat-icon-button type="button" (click)="skip(-skipSeconds)" [attr.aria-label]="'Common.Controls.SkipBack' | translate" [matTooltip]="'Common.Controls.SkipBack' | translate">
		<mat-icon aria-hidden="true">replay_10</mat-icon>
	</button>
	<button mat-icon-button type="button" (click)="skip(skipSeconds)" [attr.aria-label]="'Common.Controls.SkipForward' | translate" [matTooltip]="'Common.Controls.SkipForward' | translate">
		<mat-icon aria-hidden="true">forward_10</mat-icon>
	</button>
</div>
